import { Heading } from "@components/atoms/Heading"
import { Button } from "@components/atoms/Button"
import { Col, Container, Grid } from "@components/layout/Grid"
import { Card } from "@components/molecules/Cards"
import { Swiper, SwiperSlide } from "@components/atoms/Swiper"
import { EditableText } from "eddev/blocks"
import { ArticleCardFragment } from "../../types.graphql"

export const LatestNewsSlider = ({ title, articles }: { title?: string; articles: ArticleCardFragment[] }) => {
  return (
    <>
      {articles && (
        <Container
          className={[
            "mt-4 mb-5 [&_h5]:type-title-xs [&_h5]:my-0",
            "[&>.--grid:nth-of-type(1)>div]:flex [&>.--grid:nth-of-type(1)>div]:items-center [&>.--grid:nth-of-type(1)>div]:py-4",
            "wp:[&>.--grid:nth-of-type(1)]:gap-3 wp:[&>.--grid:nth-of-type(2)]:gap-3",
          ].join(" ")}
        >
          <Grid>
            <Col initial={8}>
              {title ? (
                <Heading as="h5" dangerouslySetInnerHTML={{ __html: title }} />
              ) : (
                <EditableText as="h5" store="title" placeholder="Enter title..." />
              )}
            </Col>
            <Col initial={4} className="justify-end md:pr-[80px] lg:pr-[100px]">
              <Button color="white" size="small" href="/newsroom">
                View all
              </Button>
            </Col>
          </Grid>

          <Grid>
            <Col initial={12}>
              <style
                dangerouslySetInnerHTML={{
                  __html: `
                .latest-news-swiper {
                  overflow: visible !important;
                  padding-bottom: 40px;

                  div[class^='swiper-button'] {
                    top: auto;
                    bottom: 0;
                    right: 0;
                    left: auto;
                    width: 27px;
                    height: 27px;
                    color: #222222;
                    box-shadow: inset 0px 0px 0px 1px #222222;
                    border-radius: 6px;
                    transition: all .35s cubic-bezier(.19,1,.22,1);

                    &:after {
                      font-size: 16px !important;
                    }
                    
                    svg {
                      width: 5px;
                      height: auto;

                      path {
                        stroke: currentColor;
                        stroke-width: 2px;
                      }
                    }

                    &:hover {
                      background: #5E5E5E;
                      box-shadow: inset 0px 0px 0px 1px #5E5E5E;
                      color: #FFFFFF;
                    }

                    &:active {
                      background: #222222;
                      box-shadow: inset 0px 0px 0px 1px #222222;
                      color: #FFFFFF;
                    }

                    &:disabled {
                      background: transparent;
                      box-shadow: inset 0px 0px 0px 1px #8E8E8E;
                      color: #8E8E8E;
                    }
                  }

                  .swiper-button-prev {
                    margin-right: 36px;
                  }
                }

                @media only screen and (min-width: 900px) {
                  .latest-news-swiper {
                    padding-bottom: 0;

                    div[class^='swiper-button'] {
                      bottom: auto;
                      top: -18px;
                    }
                  }
                }

                @media only screen and (min-width: 1200px) {
                  .latest-news-swiper {
                    div[class^='swiper-button'] {
                      bottom: auto;
                      top: -34px;
                      width: 40px;
                      height: 40px;
                    }

                    .swiper-button-prev {
                      margin-right: 50px;
                    }
                  }
                }
              `,
                }}
              />
              <Swiper
                className="latest-news-swiper"
                spaceBetween={24}
                autoplay={{
                  delay: 5000,
                }}
                navigation
                breakpoints={{
                  1200: {
                    slidesPerView: 3,
                  },
                  900: {
                    slidesPerView: 2.25,
                  },
                  0: {
                    slidesPerView: 1.15,
                  },
                }}
              >
                {articles.map((article, i) => (
                  <SwiperSlide key={i} style={{ display: "flex", height: "auto" }}>
                    <Card type="news" {...article} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Grid>
        </Container>
      )}
    </>
  )
}
